"use client";

import { c as _c } from "react/compiler-runtime";
import * as React from "react";
import { Activity, Brain, Clock, FileText, HelpCircle, LayoutDashboard, Mic, Plus } from "lucide-react";
type NavItem = {
  title: string;
  icon: React.ComponentType<{
    size?: number;
    className?: string;
  }>;
  url: string;
};
{/* ============================================================
    MA2TIC ORG — Proprietary Software
    © 2026 MA2TIC. All Rights Reserved.
     Licensed to: MA2TIC Organisation
    Owners: Archana Thakur | Tanisha Bhardwaj |
            Manika Kutiyal | Aditya Verma
     NOTICE: This software is proprietary and confidential.
    Unauthorized copying, fragmentation, redistribution,
    or publication of this code, in whole or in part,
    is strictly prohibited without prior written permission
    from the MA2TIC development team.
     For permissions and licensing inquiries, contact MA2TIC.
    ============================================================ */}
type WorkspaceSidebarProps = {
  onNewAnalysis?: () => void;
  onNavItemClick?: (item: NavItem) => void;
  activePage?: string;
  userName?: string;
  userEmail?: string;
  onLogout?: () => void;
};
{/* ============================================================
    MA2TIC ORG — Proprietary Software
    © 2026 MA2TIC. All Rights Reserved.
     Licensed to: MA2TIC Organisation
    Owners: Archana Thakur | Tanisha Bhardwaj |
            Manika Kutiyal | Aditya Verma
     NOTICE: This software is proprietary and confidential.
    Unauthorized copying, fragmentation, redistribution,
    or publication of this code, in whole or in part,
    is strictly prohibited without prior written permission
    from the MA2TIC development team.
     For permissions and licensing inquiries, contact MA2TIC.
    ============================================================ */}
export function WorkspaceSidebar(t0) {
  const $ = _c(54);
  const {
    onNewAnalysis,
    onNavItemClick,
    activePage: t1,
    userName: t2,
    userEmail: t3,
    onLogout
  } = t0;
  const activePage = t1 === undefined ? "analysis" : t1;
  const userName = t2 === undefined ? "Researcher" : t2;
  const userEmail = t3 === undefined ? "" : t3;
  const [showAccountActions, setShowAccountActions] = React.useState(false);
  let t4;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = [{
      title: "New Analysis",
      icon: Plus,
      url: "#"
    }, {
      title: "Dashboard",
      icon: LayoutDashboard,
      url: "#"
    }, {
      title: "History",
      icon: Clock,
      url: "#"
    }, {
      title: "Reports",
      icon: FileText,
      url: "#"
    }];
    $[0] = t4;
  } else {
    t4 = $[0];
  }
  const navMain = t4;
  let t5;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = [{
      title: "About",
      icon: HelpCircle,
      url: "#"
    }];
    $[1] = t5;
  } else {
    t5 = $[1];
  }
  const navSecondary = t5;
  let t6;
  if ($[2] !== onNavItemClick || $[3] !== onNewAnalysis) {
    t6 = item => {
      if (item.title === "New Analysis") {
        onNewAnalysis?.();
      }
      onNavItemClick?.(item);
    };
    $[2] = onNavItemClick;
    $[3] = onNewAnalysis;
    $[4] = t6;
  } else {
    t6 = $[4];
  }
  const handleClick = t6;
  let t7;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <Brain size={18} style={{
      color: "var(--nt-icon)"
    }} />;
    $[5] = t7;
  } else {
    t7 = $[5];
  }
  let t8;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <div className="px-3 py-3 mb-2"><div className="flex items-center gap-2">{t7}<span className="text-xl font-semibold tracking-tight" style={{
          color: "var(--nt-text-hi)"
        }}>cortexflow</span></div></div>;
    $[6] = t8;
  } else {
    t8 = $[6];
  }
  let t9;
  if ($[7] !== handleClick) {
    t9 = () => handleClick(navMain[0]);
    $[7] = handleClick;
    $[8] = t9;
  } else {
    t9 = $[8];
  }
  let t10;
  let t11;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = {
      border: "1px solid var(--nt-glass-border)"
    };
    t11 = <Mic size={14} />;
    $[9] = t10;
    $[10] = t11;
  } else {
    t10 = $[9];
    t11 = $[10];
  }
  let t12;
  if ($[11] !== t9) {
    t12 = <button onClick={t9} className="nt-nav-btn mx-1 mb-2 flex items-center gap-2 rounded-lg px-3 py-2 text-sm font-medium" style={t10}>{t11}New Analysis</button>;
    $[11] = t9;
    $[12] = t12;
  } else {
    t12 = $[12];
  }
  let t13;
  if ($[13] !== activePage || $[14] !== handleClick) {
    t13 = <div className="flex flex-col gap-0.5 px-1">{navMain.slice(1).map(item_0 => {
        const Icon = item_0.icon;
        const isActive = activePage === item_0.title.toLowerCase();
        return <button key={item_0.title} onClick={() => handleClick(item_0)} className={`nt-nav-btn flex items-center gap-2.5 rounded-lg px-3 py-2 text-sm w-full text-left ${isActive ? "nt-active" : ""}`}><Icon size={15} />{item_0.title}</button>;
      })}</div>;
    $[13] = activePage;
    $[14] = handleClick;
    $[15] = t13;
  } else {
    t13 = $[15];
  }
  let t14;
  if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = <div className="mt-4 mb-1 px-4"><span className="text-[10px] uppercase tracking-widest font-medium" style={{
        color: "var(--nt-text-ghost)"
      }}>Analysis</span></div>;
    $[16] = t14;
  } else {
    t14 = $[16];
  }
  let t15;
  if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
    t15 = [{
      title: "Brain Regions",
      icon: Brain,
      url: "#"
    }, {
      title: "Biomarkers",
      icon: Activity,
      url: "#"
    }];
    $[17] = t15;
  } else {
    t15 = $[17];
  }
  let t16;
  if ($[18] !== handleClick) {
    t16 = <div className="flex flex-col gap-0.5 px-1">{t15.map(item_1 => {
        const Icon_0 = item_1.icon;
        return <button key={item_1.title} onClick={() => handleClick(item_1)} className="nt-nav-btn flex items-center gap-2.5 rounded-lg px-3 py-2 text-sm w-full text-left"><Icon_0 size={15} />{item_1.title}</button>;
      })}</div>;
    $[18] = handleClick;
    $[19] = t16;
  } else {
    t16 = $[19];
  }
  let t17;
  if ($[20] === Symbol.for("react.memo_cache_sentinel")) {
    t17 = <div className="flex-1" />;
    $[20] = t17;
  } else {
    t17 = $[20];
  }
  let t18;
  if ($[21] !== handleClick) {
    t18 = <div className="flex flex-col gap-0.5 px-1 mb-2">{navSecondary.map(item_2 => {
        const Icon_1 = item_2.icon;
        return <button key={item_2.title} onClick={() => handleClick(item_2)} className="nt-nav-btn flex items-center gap-2.5 rounded-lg px-3 py-2 text-sm w-full text-left"><Icon_1 size={15} />{item_2.title}</button>;
      })}</div>;
    $[21] = handleClick;
    $[22] = t18;
  } else {
    t18 = $[22];
  }
  let t19;
  if ($[23] !== onLogout) {
    t19 = () => {
      if (!onLogout) {
        return;
      }
      setShowAccountActions(_temp);
    };
    $[23] = onLogout;
    $[24] = t19;
  } else {
    t19 = $[24];
  }
  let t20;
  if ($[25] === Symbol.for("react.memo_cache_sentinel")) {
    t20 = {
      background: "var(--nt-active)",
      color: "var(--nt-text-lo)"
    };
    $[25] = t20;
  } else {
    t20 = $[25];
  }
  let t21;
  if ($[26] !== userName?.[0]) {
    t21 = userName?.[0]?.toUpperCase() ?? "R";
    $[26] = userName?.[0];
    $[27] = t21;
  } else {
    t21 = $[27];
  }
  let t22;
  if ($[28] !== t21) {
    t22 = <div className="w-6 h-6 rounded-full flex items-center justify-center text-xs font-medium shrink-0" style={t20}>{t21}</div>;
    $[28] = t21;
    $[29] = t22;
  } else {
    t22 = $[29];
  }
  let t23;
  if ($[30] === Symbol.for("react.memo_cache_sentinel")) {
    t23 = {
      color: "var(--nt-text-md)"
    };
    $[30] = t23;
  } else {
    t23 = $[30];
  }
  let t24;
  if ($[31] !== userName) {
    t24 = <span className="text-xs font-medium truncate" style={t23}>{userName}</span>;
    $[31] = userName;
    $[32] = t24;
  } else {
    t24 = $[32];
  }
  let t25;
  if ($[33] !== userEmail) {
    t25 = userEmail && <span className="text-[10px] truncate" style={{
      color: "var(--nt-text-ghost)"
    }}>{userEmail}</span>;
    $[33] = userEmail;
    $[34] = t25;
  } else {
    t25 = $[34];
  }
  let t26;
  if ($[35] !== t24 || $[36] !== t25) {
    t26 = <div className="flex flex-col min-w-0 flex-1">{t24}{t25}</div>;
    $[35] = t24;
    $[36] = t25;
    $[37] = t26;
  } else {
    t26 = $[37];
  }
  let t27;
  if ($[38] !== t19 || $[39] !== t22 || $[40] !== t26) {
    t27 = <button type="button" onClick={t19} className="nt-nav-btn w-full flex items-center gap-2.5 rounded-lg px-3 py-2 cursor-pointer text-left">{t22}{t26}</button>;
    $[38] = t19;
    $[39] = t22;
    $[40] = t26;
    $[41] = t27;
  } else {
    t27 = $[41];
  }
  let t28;
  if ($[42] !== onLogout || $[43] !== showAccountActions) {
    t28 = showAccountActions && onLogout && <button type="button" onClick={onLogout} className="mt-1 ml-8 px-2.5 py-1 rounded-md text-[10px] font-medium" style={{
      color: "#D85A30",
      border: "1px solid rgba(216, 90, 48, 0.28)",
      background: "rgba(216, 90, 48, 0.08)"
    }}>Logout</button>;
    $[42] = onLogout;
    $[43] = showAccountActions;
    $[44] = t28;
  } else {
    t28 = $[44];
  }
  let t29;
  if ($[45] !== t27 || $[46] !== t28) {
    t29 = <div className="mx-1">{t27}{t28}</div>;
    $[45] = t27;
    $[46] = t28;
    $[47] = t29;
  } else {
    t29 = $[47];
  }
  let t30;
  if ($[48] !== t12 || $[49] !== t13 || $[50] !== t16 || $[51] !== t18 || $[52] !== t29) {
    t30 = <aside className="sidebar-content-scrim flex flex-col h-full w-[240px] shrink-0 py-4 px-2 gap-1">{t8}{t12}{t13}{t14}{t16}{t17}{t18}{t29}</aside>;
    $[48] = t12;
    $[49] = t13;
    $[50] = t16;
    $[51] = t18;
    $[52] = t29;
    $[53] = t30;
  } else {
    t30 = $[53];
  }
  return t30;
}
function _temp(prev) {
  return !prev;
}